import { ShopPage } from "@tenant/hotels";
import { PackagesHotelSlotProvider } from "@tenant/packages";

export const PackageHotelShopPage = (
  props: React.ComponentProps<typeof ShopPage>
) => {
  return (
    <PackagesHotelSlotProvider>
      <ShopPage {...props} />
    </PackagesHotelSlotProvider>
  );
};
